export const compressFileWithGzip = async (file: File): Promise<Blob> => {
  // Read the file as an ArrayBuffer
  const arrayBuffer = await file.arrayBuffer();
  const stream = new Blob([arrayBuffer]).stream();

  // Use the CompressionStream API (gzip format)
  const compressedStream = stream.pipeThrough(new CompressionStream('gzip'));

  // Collect the result as a Blob
  const compressedBlob = await new Response(compressedStream).blob();

  return compressedBlob;
};
